import { checkIfNameExists, findCombinationIndex } from '../../../../../../validations/validations';

function findViolationsAnnotations(
  annotationName,
  annotationType,
  setLock,
  newSelected,
  entity,
  entityName,
  attributeType,
  customAttributeType,
  attributesTypes,
  entities,
  attributeTypeService,
  functionName,
  defineServiceParam,
  connectedService,
  requestParam,
  displayFlowData,
  href,
  hrefChecked,
  target,
  targetPageChecked
) {

  // If annotation name is empty and annotation type is none then set lock to true
  if (annotationName === '' && annotationType !== 'none') {
    setLock(true);
  }
  // If annotation name is empty and annotation link has been given then set lock to true
  else if (
    annotationName === '' &&
    (newSelected === true || (newSelected === false && entity !== 'none'))
  ) {
    setLock(true);
  }
  // If annotationType is none  and annotation name has been given then set lock to true
  else if (annotationType === 'none' && annotationName !== '') {
    setLock(true);
  }
  // If annotationType is none and annotation link has been given then set lock to true
  else if (
    annotationType === 'none' &&
    ((newSelected === true && entityName === '') || (newSelected === false && entity !== 'none'))
  ) {
    setLock(true);
  } else if (
    annotationType === 'attribute' &&
    attributeType === 'entity' &&
    (checkIfNameExists(customAttributeType, attributesTypes) === true || customAttributeType === '')
  ) {
    setLock(true);
  }
  // If new annotation link given is already existed then set lock to true
  else if (checkIfNameExists(entityName, entities) === true && newSelected === true) {
    setLock(true);
  }
  // If new annotation link is empty then set lock to true
  else if (entityName === '' && newSelected === true && annotationName !== '') {
    setLock(true);
  } else if (newSelected === false && entity === 'none' && annotationName !== '') {
    setLock(true);
  } else if (annotationType === 'attribute' && attributeType === 'none') {
    setLock(true);
  } else if (
    attributeType === 'service' &&
    attributeTypeService === 'none' &&
    annotationType === 'attribute'
  ) {
    setLock(true);
  } else if (annotationType === 'method' && functionName === 'none') {
    setLock(true);
  } else if (/[\W_]+/.test(annotationName)) {
    setLock(true);
  } else if (/[A-Z\W\d_]+/.test(entityName)) {
    setLock(true);
  } else if ( (functionName === `service${entity}` || functionName === `service${entityName}` ) && attributeTypeService === 'none'){
    setLock(true);
  } else if( defineServiceParam === true && connectedService === 'none'){
    setLock(true);
  } else if( defineServiceParam === true && requestParam === 'none' ){
    setLock(true);
  } else if( displayFlowData === true && hrefChecked === true && href ===''){
    setLock(true);
  } else if( displayFlowData === true && targetPageChecked === true && target === 'none'){
    setLock(true);
  } else {
    setLock(false);
  }
}

function findDifferencesAnnotations(
  setCompareLock,
  annotationType,
  attributeType,
  attributeTypeService,
  annotationName,
  selectedProject,
  entity,
  newSelected,
  entityName,
  annotationTable,
  customAttributeType,
  functionName,
  serviceSelectedAttr
) {
  const combinationIndex = findCombinationIndex(annotationName, selectedProject);

  if (combinationIndex !== -1) {
    const combination = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0]
      .combinations[combinationIndex];

    if (combination.annotationLink !== entity && newSelected === false) {
      setCompareLock(true);
    } else if (combination.annotationLink !== entityName && newSelected === true) {
      setCompareLock(true);
    } else if (combination.annotationTable !== annotationTable) {
      setCompareLock(true);
    } else if (combination.annotationType !== annotationType) {
      setCompareLock(true);
    } else if (combination.attributeType !== attributeType) {
      setCompareLock(true);
    } else if (combination.attributeTypeService !== attributeTypeService) {
      setCompareLock(true);
    } else if (combination.customAttributeType !== customAttributeType) {
      setCompareLock(true);
    } else if (combination.method !== functionName) {
      setCompareLock(true);
    } else if (combination.attributeType === 'service' && combination.serviceAttr !== serviceSelectedAttr){
      setCompareLock(true);
    } else {
      setCompareLock(false);
    }
  } else {
    setCompareLock(false);
  }
}

export { findViolationsAnnotations, findDifferencesAnnotations };
